import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actions } from 'store/unSubscribe';
import { actions as campaignActions } from 'store/campaign';
import { ToolbarV2, TableComponentV2 } from 'components';
import { unSubscribeTableTitles } from 'constants.js';
import DisplayModal from 'components/DisplayModal';
import { updateUnsubscribeFilters, resetUnsubscribeFilters } from 'store/unSubscribe/actions';
const { getPaginatedSubscriptions, updateCurrentEdit } = actions;
const { getPaginatedCampaigns } = campaignActions;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  checkbox: {
    paddingLeft: theme.spacing(1)
  },
  subCheckbox: {
    paddingLeft: theme.spacing(1)
  },
  submitButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2)
  },
  options: {
    display: 'flex',
    flexDirection: 'column'
  },
  or: {
    display: 'flex',
    justifyContent: 'center'
  },
  title: {
    padding: theme.spacing(1)
  },
  details: {
    maxHeight: '230px',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 0px'
  }
}));

const UnSubscribe = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const unSubscribeList = useSelector(store => store.unSubscribe.paginatedList);
  const isLoading = useSelector(store => store.unSubscribe.gettingPaginated);
  const paginatedCampaigns = useSelector(store => store.campaign.paginatedList);
  const isCampaignFilterLoading = useSelector(store => store.campaign.gettingPaginated);
  const filters = useSelector(store => store.unSubscribe.filters);

  const optionsToFilterPromotional = [
    { name: 'promotional', value: 'Unsubscribed', checked: false },
    { name: 'promotional', value: 'Subscribed', checked: false }
  ];

  const optionsToFilterTransactional = [
    { name: 'transactional', value: 'Unsubscribed', checked: false },
    { name: 'transactional', value: 'Subscribed', checked: false }
  ];
  const optionsToFilterPaginatedCampaigns = paginatedCampaigns
  ? paginatedCampaigns.map(campaign => {
      return { name: 'campaigns', value: campaign.uuid, label: campaign.name, checked: false };
    })
  : [];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRow, setcurrentRow] = useState({});

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    dispatch(getPaginatedSubscriptions({ force: true }));
  }, []);

  const getTransformedDetails = row => {
    return {
      'Tenant Id': row.tenantId,
      'Business Context Id': row.businessContextId,
      'Email': row.emailAddress,
      'All Promotional Campaigns': row.allPromotionalCampaignsString,
      'All Transactional Campaigns': row.allTransactionalCampaignsString,
      'Excluded Campaigns': row.campaignUuids
    }
  };

  const getActionButtons = row => [
    {
      name: 'View Details',
      action: ['ACTION', () => onViewSubscriptionDetails(row)],
      hasModal: true
    },
    {
      name: 'Resubscribe',
      action: ['ACTION', () => onResubscribe(row)]
    }
  ];

  const onViewSubscriptionDetails = async (row) => {
    let subscriptionInfo = getTransformedDetails(row);
    setcurrentRow(subscriptionInfo);
    setIsModalOpen(prev => !prev);
  };

  const onResubscribe = (row) => {
    dispatch(updateCurrentEdit(row));
    history.push(`/unsubscribe/Edit`);
  };

  const handlePaginatedCampaignsChange = (paginatedCampaigns) => {
    let filterPaginatedCampaigns = new Map(filters?.filterPaginatedCampaigns.map(item => [item.value, item]));
    paginatedCampaigns.forEach(item => filterPaginatedCampaigns.set(item.value, item));
    const updatedCampaigns = Array.from(filterPaginatedCampaigns.values()).filter(option => option.checked);
    dispatch(updateUnsubscribeFilters({ filterPaginatedCampaigns: updatedCampaigns, pageNo: 0 }));
  }

  const filterOptions = {
    filters: [
      {
        options: optionsToFilterPromotional.map(option => {
          if (filters?.filterAllPromotional?.includes(option.value)) {
            option.checked = true;
          }
          return option;
        }),
        title: 'All Promotional Campaigns',
        values: filters?.filterAllPromotional,
        onChange: types => dispatch(updateUnsubscribeFilters({ filterAllPromotional: types, pageNo: 0 }))
      },
      {
        options: optionsToFilterTransactional.map(option => {
          if (filters?.filterAllTransactional?.includes(option.value)) {
            option.checked = true;
          }
          return option;
        }),
        title: 'All Transactional Campaigns',
        values: filters?.filterAllTransactional,
        onChange: types => dispatch(updateUnsubscribeFilters({ filterAllTransactional: types, pageNo: 0 }))
      }
    ],
    paginatedFilter: [
      {
        selectedOptions: filters?.filterPaginatedCampaigns || [],
        isLoading: isCampaignFilterLoading,
        options: optionsToFilterPaginatedCampaigns.map(option => {
          if (filters?.filterPaginatedCampaigns.map(campaign => campaign.value).includes(option.value)) {
            option.checked = true;
          }
          return option;
        }) || [],
        title: 'Campaigns',
        onChange: handlePaginatedCampaignsChange,
        searchPlaceholder: 'Search Campaigns',
        filterType: 'campaign',
        filterAction: getPaginatedCampaigns({ force: true, isFilter: true })
      }
    ],
    resetFilters: () => dispatch(resetUnsubscribeFilters())
  };

  const searchOptions = {
    searchPlaceholder: 'Search Email Address',
    searchAction: (payload) => dispatch(updateUnsubscribeFilters(payload)),
    searchKey: 'searchInput',
    searchValue: filters?.searchInput || ''
  };

  return (
    <div className={classes.root}>
      <ToolbarV2
        searchOptions={searchOptions}
        filterOptions={filterOptions}
        buttonsGroup={[]}
        action={getPaginatedSubscriptions({ force: true })}
      />
      <div className={classes.content}>
        <TableComponentV2
          isLoading={isLoading}
          tableTitles={unSubscribeTableTitles}
          onDoubleClickRow={row => onViewSubscriptionDetails(row)}
          actionButtonOptions={row => getActionButtons(row)}
          filteredRows={unSubscribeList}
          action={getPaginatedSubscriptions({ force: true })}
          filterValues={filters}
          filterAction={(payload) => dispatch(updateUnsubscribeFilters(payload))}
        />
      </div>
      <DisplayModal
        batch={currentRow}
        title={'Unsubscribe Details'}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isIndentationRequired={true}
        size={'md'}
        showNumberedInnerList={true}
      />
    </div>
  );
};

export default UnSubscribe;
